import { InputProps } from '..';
import { INPUT_TYPE } from '../../../utils/constants/input';

export const handleClickClear = (onChange: InputProps['onChange']) => {
  if (onChange !== undefined) {
    onChange('');
  }
};

type IHandleChangeProps = {
  event: React.ChangeEvent<HTMLInputElement>;
  onChange: InputProps['onChange'];
  type: InputProps['type'];
  customRegex?: RegExp;
};
export const handleChange = ({ event, onChange, type, customRegex = REG_EXP[type] }: IHandleChangeProps) => {
  const { value: newValue } = event.target;

  if (customRegex.test(newValue)) {
    if (onChange !== undefined) {
      onChange(newValue);
    }
  }
};

type IRegExp = {
  [key in typeof INPUT_TYPE[number]]: RegExp;
};

export const REG_EXP: IRegExp = {
  text: /^$|^(\w|\d|\s)+$/,
  extendedText: /^$|^(\w|\d|\s|\:|\-)+$/,
  number: /^$|^\d+$/,
  decimal: /^(\+|\-)?(?=\.\d|\d)?(?:\d+)?(?:\.?\d{0,2})?$/,
};
